import React from "react";
import { sendToCountries } from "../utils/countries";

const availableCountries = sendToCountries.map((c) => c.name).join(", ");

function AvailableCountries() {
  return (
    <div className="position-absolute start-0 w-100" style={{ bottom: "18%" }}>
      <div className="container">
        <div className=" d-flex align-items-center justify-content-center text-dark">
          <p className="fs-16 mb-0">
            <span className="fw-bold">Send Money to: </span>
            {availableCountries}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AvailableCountries;
